import Vue, { PropType } from 'vue';

import commonStyle from "./css/common.module.css";
import style from "./css/TopMenu.module.css";

// TODO: merge with `MobileMenu` types
interface IMenuButton {
  label: string;
  onClick: () => void;
  highlight?: boolean;
}

// TODO: merge with `MobileMenu` types
export type DesktopMenuButtonList = Array<IMenuButton>;

export default Vue.extend({
  props: {
    open: Boolean,
    options: Array as PropType<DesktopMenuButtonList>,
  },
  render() {
    const isHighlight = (option: IMenuButton) => Boolean(option.highlight); 
    return (
      <div class={this.open ? style.desktopMenuOpen : style.desktopMenu}>
        { this.options.map(option => (
          <div>
            <button class={{
              [style.menuButton]: true,
              [style.subMenuButton]: !isHighlight(option),
              [style.subMenuButtonSelected]: isHighlight(option)
            }} onClick={option.onClick}>
              <div class={commonStyle.buttonLabel}>{ option.label }</div>
            </button>
            <br/>
          </div>
        ))}
      </div>
    );
  },
});
